import Vue from 'vue'
import Router from 'vue-router'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _23152d0a = () => interopDefault(import('..\\pages\\coming-soon\\index.vue' /* webpackChunkName: "pages_coming-soon_index" */))
const _fd0502f8 = () => interopDefault(import('..\\pages\\eligibility\\index.vue' /* webpackChunkName: "pages_eligibility_index" */))
const _e10cd80e = () => interopDefault(import('..\\pages\\error.vue' /* webpackChunkName: "pages_error" */))
const _2cad7634 = () => interopDefault(import('..\\pages\\failed\\index.vue' /* webpackChunkName: "pages_failed_index" */))
const _092ff830 = () => interopDefault(import('..\\pages\\not-eligible.vue' /* webpackChunkName: "pages_not-eligible" */))
const _1ef5bc4d = () => interopDefault(import('..\\pages\\patient-information\\index.vue' /* webpackChunkName: "pages_patient-information_index" */))
const _054b59b5 = () => interopDefault(import('..\\pages\\thank-you\\index.vue' /* webpackChunkName: "pages_thank-you_index" */))
const _64cd30ba = () => interopDefault(import('..\\pages\\unlock.vue' /* webpackChunkName: "pages_unlock" */))
const _5dc7a84c = () => interopDefault(import('..\\pages\\errors\\400.vue' /* webpackChunkName: "pages_errors_400" */))
const _5dab794a = () => interopDefault(import('..\\pages\\errors\\401.vue' /* webpackChunkName: "pages_errors_401" */))
const _5d731b46 = () => interopDefault(import('..\\pages\\errors\\403.vue' /* webpackChunkName: "pages_errors_403" */))
const _5d56ec44 = () => interopDefault(import('..\\pages\\errors\\404.vue' /* webpackChunkName: "pages_errors_404" */))
const _0602671b = () => interopDefault(import('..\\pages\\errors\\500.vue' /* webpackChunkName: "pages_errors_500" */))
const _4bb375c3 = () => interopDefault(import('..\\pages\\index.vue' /* webpackChunkName: "pages_index" */))

// TODO: remove in Nuxt 3
const emptyFn = () => {}
const originalPush = Router.prototype.push
Router.prototype.push = function push (location, onComplete = emptyFn, onAbort) {
  return originalPush.call(this, location, onComplete, onAbort)
}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: decodeURI('#{BasePath}#/'),
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/coming-soon",
    component: _23152d0a,
    name: "coming-soon"
  }, {
    path: "/eligibility",
    component: _fd0502f8,
    name: "eligibility"
  }, {
    path: "/error",
    component: _e10cd80e,
    name: "error"
  }, {
    path: "/failed",
    component: _2cad7634,
    name: "failed"
  }, {
    path: "/not-eligible",
    component: _092ff830,
    name: "not-eligible"
  }, {
    path: "/patient-information",
    component: _1ef5bc4d,
    name: "patient-information"
  }, {
    path: "/thank-you",
    component: _054b59b5,
    name: "thank-you"
  }, {
    path: "/unlock",
    component: _64cd30ba,
    name: "unlock"
  }, {
    path: "/errors/400",
    component: _5dc7a84c,
    name: "errors-400"
  }, {
    path: "/errors/401",
    component: _5dab794a,
    name: "errors-401"
  }, {
    path: "/errors/403",
    component: _5d731b46,
    name: "errors-403"
  }, {
    path: "/errors/404",
    component: _5d56ec44,
    name: "errors-404"
  }, {
    path: "/errors/500",
    component: _0602671b,
    name: "errors-500"
  }, {
    path: "/",
    component: _4bb375c3,
    name: "index"
  }],

  fallback: false
}

export function createRouter () {
  return new Router(routerOptions)
}
